import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "../css/font-awesome.css"
import "bootstrap/dist/css/bootstrap.css"
import "../css/style.css"
import logo from "../images/logo-dark.png"



const Header = ({ siteTitle }) => (
  <header className="site-header">
    <div className="notice">Free Shipping in the USA</div>
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-4 align-self-center">
          <Link className="header-logo" to="/"><img src={logo} alt="Patty's Home Made Gifts"></img></Link>
        </div>
        <div className="col-sm-12 col-md-8 align-self-center">
          <nav>
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <Link to="/">Categories</Link>
              </li>
              <li className="nav-item">
                <Link to="/quick-search">Quick Search</Link>
              </li>
              <li className="nav-item">
                <Link to="/contact">Contact</Link>
              </li>
              <li className="nav-item">
                <a href="http://www.etsy.com/shop/PattysHomemadeGifts" target="blank" rel="noopener noreferrer">Etsy Shop</a>
              </li>
            </ul>
            {/* <div className="header-cart">
              <Link className="Header__summary snipcart-summary snipcart-checkout" to="#">
                <i className="fas fa-cart-plus"></i>
              </Link>
            </div> */}
          </nav>
        </div>
      </div>
    </div>

  </header >
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
